/// <reference path="../../TypeLite.Net4.d.ts" />
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { OverlayWindowComponent } from '../../components/overlayWindow/overlayWindow';
import { Layout, SelectableItemContainer } from '../../components/selectableItem/selectableItemContainer';
import { ISelectableItem, SelectableItemConverter } from '../../components/selectableItem/selectableItemConverters';
import { ResourceProvider } from '../../resourceProvider';
import { ApplicationState } from '../../store';
import { hideCountriesPage } from '../../store/countriesPage/actions';
import { applyCountryFilter } from '../../store/filterPage/actions';
import { CountryFilterActionPayload, FilterState } from '../../store/filterPage/types';
import { TrackingProvider } from '../../tracking/trackingProvider';
import { getDefaultCountry } from '../../utils/api';

interface PropsFromState {
	readonly isVisible: boolean,
	readonly countries: ISelectableItem[],
	readonly selectedCountry: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel,
	readonly importerCountryCode: string,
	readonly actualFilter: FilterState,
	readonly trackingProvider: TrackingProvider
}

interface ICountriesPageState {
	readonly selectedItem: ISelectableItem,
	readonly isChangedSelectedItem: boolean
}

interface PropsFromDispatch {
	readonly applyCountryFilter: typeof applyCountryFilter,
	readonly hideCountriesPage: typeof hideCountriesPage
}

type ICountriesPageProps = PropsFromState & PropsFromDispatch;

class CountriesPage extends React.Component<ICountriesPageProps, ICountriesPageState> {
	constructor(props: ICountriesPageProps) {
		super(props);

		this.changeSelectedCountry = this.changeSelectedCountry.bind(this);
		this.submitSelectedCountry = this.submitSelectedCountry.bind(this);
		this.hideCountriesPage = this.hideCountriesPage.bind(this);
		this.state = { selectedItem: null, isChangedSelectedItem: false };
	}

	public componentDidUpdate(prevProps: ICountriesPageProps) {
		if (this.props.isVisible && this.props.isVisible !== prevProps.isVisible) {
			this.props.trackingProvider.trackVirtualPageView(this.props.actualFilter.dataFilter.ImporterBid, this.props.actualFilter.dataFilter.Culture, 'Choose country')
		}

		if (this.props.importerCountryCode && this.props.countries && this.props.countries.length > 0 &&
			(this.props.importerCountryCode !== prevProps.importerCountryCode
				|| this.props.countries.length !== prevProps.countries.length)) {

			const defaultCountry = getDefaultCountry(this.props.countries, this.props.importerCountryCode);
			if (defaultCountry) {
				let countryFilterDataPayload = new CountryFilterActionPayload();
				countryFilterDataPayload.selectedCountry = defaultCountry.data as SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel;
				countryFilterDataPayload.isDefault = true;
				countryFilterDataPayload.isManuallySubmitted = false;
				this.props.applyCountryFilter(countryFilterDataPayload);
				this.props.trackingProvider.trackPageView(this.props.actualFilter.dataFilter.ImporterBid, this.props.actualFilter.dataFilter.Culture, countryFilterDataPayload.selectedCountry.OriginValue, this.props.actualFilter.selectedInfotaiment?.Title, this.props.actualFilter.selectedModel?.Code, this.props.actualFilter.selectedProductionInterval?.From?.ProductionDate);
			}
		}
	}

	public static getDerivedStateFromProps(nextProps: ICountriesPageProps, prevState: ICountriesPageState): ICountriesPageState {
		if ((!prevState.isChangedSelectedItem) && ((!nextProps.selectedCountry && prevState.selectedItem) ||
			(nextProps.selectedCountry && !prevState.selectedItem) ||
			(nextProps.selectedCountry && prevState.selectedItem && nextProps.selectedCountry.Code !== prevState.selectedItem.code))) {
			let selectedItem: ISelectableItem = null;
			if (nextProps.selectedCountry) {
				let filteredItem = nextProps.countries.filter((item) => ( item.code === nextProps.selectedCountry.Code ));
				if (filteredItem && filteredItem.length > 0) {
					selectedItem = filteredItem[0];
				}
			}
			return {
				isChangedSelectedItem: false,
				selectedItem
			}
		}
		return null;
	}

	public render() {
		const { countries } = this.props;
		return (
			<div className="countries-page">
				<OverlayWindowComponent title={ResourceProvider.getText('CountriesPage.Title')} onClose={this.hideCountriesPage} isVisible={this.props.isVisible} footerElement={this.renderFooter()}>
					<SelectableItemContainer id={'Countries'}
						items={countries}
						layout={Layout.Vertical}
						contentCentered={false}
						uppercase={false}
						onSelect={this.changeSelectedCountry}
						selectedItem={this.state.selectedItem}
						colStyle="selectable-item-col-country" />
				</OverlayWindowComponent >
			</div>
		)
	}

	private renderFooter(): JSX.Element {
		return (
			<div className="country-page-footer">
				{this.isSubmitButtonEnabled() ?
					<button className="btn btn-sa-primary btn-availability-primary submit-button button-border-radius" onClick={() => this.submitSelectedCountry()}>{ResourceProvider.getText('CountriesPage.Action.Submit')}</button>
					:
					<button disabled className="btn btn-sa-primary btn-availability-primary submit-button button-border-radius">{ResourceProvider.getText('CountriesPage.Action.Submit')}</button>
				}
			</div>
		);
	}

	private submitSelectedCountry(): void {
		if (this.state.selectedItem) {
			if ((!this.props.selectedCountry) || (this.state.selectedItem.data.Code !== this.props.selectedCountry.Code)) {
				let countryFilterDataPayload = new CountryFilterActionPayload();
				countryFilterDataPayload.selectedCountry = this.state.selectedItem.data as SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel;
				countryFilterDataPayload.isManuallySubmitted = true;
				this.props.applyCountryFilter(countryFilterDataPayload);
			}

			const country = this.state.selectedItem.data.OriginValue;
			this.props.trackingProvider.trackButtonClick(country, null, country, this.props.actualFilter.selectedInfotaiment?.Title, this.props.actualFilter.selectedModel?.Code, this.props.actualFilter.selectedProductionInterval?.From?.ProductionDate);
		} else {
			this.props.applyCountryFilter(null);
		}
		this.hideCountriesPage(true);
	}

	private changeSelectedCountry(selectedItem: ISelectableItem): void {
		this.setState({
			...this.state,
			selectedItem: selectedItem,
			isChangedSelectedItem: true
		});
	}

	private hideCountriesPage(onSubmit: boolean = false) {
		this.setState({
			...this.state,
			isChangedSelectedItem: false
		});
		this.props.hideCountriesPage();

		const country = onSubmit ? this.state.selectedItem.data.OriginValue : this.props.selectedCountry?.OriginValue;
		this.props.trackingProvider.trackPageView(this.props.actualFilter.dataFilter.ImporterBid, this.props.actualFilter.dataFilter.Culture, country, this.props.actualFilter.selectedInfotaiment?.Title, this.props.actualFilter.selectedModel?.Code, this.props.actualFilter.selectedProductionInterval?.From?.ProductionDate);
	}

	private isSubmitButtonEnabled(): boolean {
		return this.state.isChangedSelectedItem && (this.state.selectedItem !== null) &&
			((!this.props.selectedCountry) || this.state.selectedItem.data.Code !== this.props.selectedCountry.Code);
	}
}

const mapStateToProps = ({ countriesPage, filter, common }: ApplicationState) => ({
	isVisible: countriesPage.isVisible,
	countries: SelectableItemConverter.convertCountries(common.countries),
	selectedCountry: filter.selectedCountry,
	importerCountryCode: common.importerSettings ? common.importerSettings.CountryCode : null,
	actualFilter: filter,
	trackingProvider: common.trackingProvider
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
	applyCountryFilter: (wizardFilterActionPayload: CountryFilterActionPayload) => dispatch(applyCountryFilter(wizardFilterActionPayload)),
	hideCountriesPage: () => dispatch(hideCountriesPage())
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CountriesPage)